import { useQuery } from "@tanstack/react-query";
import { jeopardyApi } from "../api/jeopardy";

export const useFetchJeopardyTree = (selectedFilterCode: string | null) => {

    const { data, isLoading, isSuccess, isRefetching, isError, error } = useQuery({
        queryKey: ["jeopardy-tree", selectedFilterCode],
        queryFn: () => jeopardyApi.fetchJeopardyTree(selectedFilterCode),
    });

    return { data: isSuccess ? data.data.items : [], isLoading: isLoading || isRefetching, isError, error };

};